import React from "react";
import { Form, Formik } from "formik";
import TextBox from "../../../common/TextBox";
import useUsers from "../../../../hooks/useUsers";
import { toast } from "react-toastify";
import Button from "../../../common/Button";

const ChangePassword = ({ staffId }) => {
  const { changeStaffPassword } = useUsers();
  if (!staffId) return null;

  const handleValidate = ({ password, confirmPassword }) => {
    let errors = {};

    if (!password && confirmPassword) {
      errors.password = "Required";
    }

    if (password && !confirmPassword) {
      errors.confirmPassword = "Required";
    }

    if (password && confirmPassword && password !== confirmPassword) {
      errors.password = "Password not matching";
      errors.confirmPassword = "Password not matching";
    }

    if (!password && !confirmPassword) {
      errors.password = "Required";
      errors.confirmPassword = "Required";
    }

    return errors;
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);

    try {
      await changeStaffPassword(staffId, values.password);
      toast.success("Password changed 😀");
      resetForm();
    } catch (error) {
      toast.error("Unable to change staff's password at the moment");
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <Formik
        initialValues={{ password: "", confirmPassword: "" }}
        validate={handleValidate}
        onSubmit={handleSubmit}
      >
        {(props) => {
          return (
            <Form className="admin-staffs-view-change-password">
              <h5 className="admin-staffs-view-change-password__title">
                Change Password
              </h5>
              <TextBox
                label="Password"
                name="password"
                type="password"
                autoComplete="new-password"
              />
              <TextBox
                label="Confirm Password"
                name="confirmPassword"
                type="password"
                autoComplete="new-password"
              />
              <Button
                className={"admin-staffs-view-change-password__confirm"}
                label={"Change password"}
                type="submit"
                disabled={!props.isValid}
              />
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

ChangePassword.propTypes = {};

export default ChangePassword;
